const routes = {
  shifts: 'Schulzeiten',
  passengers: 'Schüler'
};

export default routes;
